var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EC5569"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 23.7273C27 24.1613 26.8276 24.5775 26.5207 24.8843C26.2138 25.1912 25.7976 25.3636 25.3636 25.3636H10.6364C10.2024 25.3636 9.78616 25.1912 9.47928 24.8843C9.1724 24.5775 9 24.1613 9 23.7273V14.7273C9 14.2933 9.1724 13.8771 9.47928 13.5702C9.78616 13.2633 10.2024 13.0909 10.6364 13.0909H13.9091L15.5455 10.6364H20.4545L22.0909 13.0909H25.3636C25.7976 13.0909 26.2138 13.2633 26.5207 13.5702C26.8276 13.8771 27 14.2933 27 14.7273V23.7273Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 22.0909C19.8073 22.0909 21.2725 20.6257 21.2725 18.8182C21.2725 17.0107 19.8073 15.5455 17.9998 15.5455C16.1923 15.5455 14.7271 17.0107 14.7271 18.8182C14.7271 20.6257 16.1923 22.0909 17.9998 22.0909Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.d9f5e6fe3e64f5f68e35b0df2ee4b6a7.svg";
export { ForwardRef as ReactComponent };